import { useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { setAuth0TokenProvider } from '../../helpers/globalAuth';

export default function TokenInitializer() {
  const { getAccessTokenSilently } = useAuth0();

  useEffect(() => {
    // Set the token provider function in the axios instance
    setAuth0TokenProvider(getAccessTokenSilently);
  }, [getAccessTokenSilently]);

  return null;
}
